import React, { useEffect, useState } from "react";
import Header from "../sharedFiles/header/header";
import "./outGoingPayment.css";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, selectUser } from "../ReduxStore/userReducer";
import {
  fetchBranchList,
  fetchCompanyList,
  fetchOutGoingPayment,
} from "../ReduxStore/reduxThunk";
import TextField from "@mui/material/TextField";
import TablePagination from "@mui/material/TablePagination";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import axios from "axios";
import { postOutGoingPayment } from "../API/API";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Navigate, useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import Footer from "../sharedFiles/footer/footer";
import SunspotLoader from "../sharedFiles/loader/loader";
import { resetItemGroup, resetItems } from "../ReduxStore/actions";
import { toast, ToastContainer } from "react-toastify";
import { PostData } from "../API/postApi";
import FilterListIcon from "@mui/icons-material/FilterList";


const OutGoingPayment = () => {
  const userData = useSelector(selectUser);
  const OutGoingPayment = useSelector((state) => state.item.outPayment);
  const CompanyNames = useSelector((state) => state.item.CompanyList);
  const BranchNames = useSelector((state) => state.item.BranchList);
  const ApprovalList = ["All", "L1", "L2", "L3"];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 650);
  const [showItems, setShowItems] = useState(false);
  const [details, setDetails] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const databaseName = userData?.DatabaseName;
  const jwtToken = userData?.JwtToken;
  const [show, setShow] = useState(false);
  // const userId = userData?.userId;
  const userId = userData?.UserId;
  const [isLoading, setIsLoading] = useState(false);
  const [selectedApproval, setSelectedApproval] = useState(ApprovalList[0]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(
    userData ? userData.CompanyName : null
  );
  const [selectedDatabase, setSelectedDatabase] = useState(databaseName);
  const [databaseChange, setDatabaseChange] = useState(false);
  const [selectedPayTo, setSelectedPayTo] = useState(null);
  const [amount, setAmount] = useState(0);
  const fetchPayments = async () => {
    if ((userData || userData?.databaseName) && selectedDatabase) {
      try {        
        await Promise.all([
          dispatch(fetchOutGoingPayment(userId, selectedDatabase, jwtToken)),
          dispatch(fetchCompanyList(userData?.UserName, jwtToken)),
          dispatch(fetchBranchList(selectedDatabase, jwtToken)),
        ]);
      } catch (error) {
        // console.log("error :", error);
      }
    }
  };
  useEffect(() => {
    fetchPayments();
  }, [dispatch]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
// console.log("OutGoingPayment", OutGoingPayment);

  const updateOutGoingPayment = (OutGoingPayment, docEntry) => {
    const paymentIndex = OutGoingPayment.findIndex(
      (payment) => payment.docEntry === docEntry
    );
    if (paymentIndex !== -1) {
      const updatedPayment = {
        ...OutGoingPayment[paymentIndex],
        TransferReference:
          OutGoingPayment[paymentIndex].TransferReference || "",
        accNo: OutGoingPayment[paymentIndex].accNo || "",
        acctCode: OutGoingPayment[paymentIndex].acctCode || "",
        acctName: OutGoingPayment[paymentIndex].acctName || "",
        beneficiaryBank: OutGoingPayment[paymentIndex].beneficiaryBank || "",
        beneficiaryName: OutGoingPayment[paymentIndex].beneficiaryName || "",
        contactNumber: OutGoingPayment[paymentIndex].contactNumber || "",
        contactPerson: OutGoingPayment[paymentIndex].contactPerson || "",
        customerName: OutGoingPayment[paymentIndex].customerName || "",
        descrip: OutGoingPayment[paymentIndex].descrip || "",
        docCurr: OutGoingPayment[paymentIndex].docCurr || "",
        groupName: OutGoingPayment[paymentIndex].groupName || "",
        invoiceType: OutGoingPayment[paymentIndex].invoiceType || "",
        ifsc: OutGoingPayment[paymentIndex].ifsc || "",
        lastPaymentDate:null
      };
      return updatedPayment;
    } else {
      // console.log("Payment with the specified docEntry not found.");
      return null;
    }
  };

  const handleApprove = async (docEntry) => {
  
    
    setIsLoading(true);
    const updatedPayment = updateOutGoingPayment(OutGoingPayment, docEntry);
    // console.log("updatedPayment :", updatedPayment);
    if (updatedPayment) {
      if (userData.AppLevel >= 1) {
        updatedPayment.level1StatusId = 1;
      }
      if (userData.AppLevel >= 2) {
        updatedPayment.level2StatusId = 1;
      }
      if (userData.AppLevel >= 3) {
        updatedPayment.level3StatusId = 1;
      }
    //   let dataToSend;
    //   // if (databaseChange) {
    //  dataToSend = {
    //     companyName: selectedDatabase,
    //     payment: updatedPayment,
    //   };
    let dataToSend = {
      companyName: selectedDatabase,
      payment: {
        docEntry: updatedPayment.docEntry,  // Make sure docEntry is present in updatedPayment
        level1StatusId: updatedPayment.level1StatusId || 0,
        level2StatusId: updatedPayment.level2StatusId || 0,
        level3StatusId: updatedPayment.level3StatusId || 0,
        transferReference: updatedPayment.TransferReference || "",}}
      // if (!databaseChange){
      //   dataToSend = {
      //     companyName: databaseName,
      //     payment: updatedPayment,
      //   };
      // }
      try {
        // const response = await axios.post(postOutGoingPayment, dataToSend, {
        //   headers: {
        //     wg_token: jwtToken,
        //   },
        // });
        const response = await PostData(postOutGoingPayment,dataToSend
          ,jwtToken
          ,dispatch
          ,navigate
        )
        if (response === "OK") {
          fetchPayments();
          setIsLoading(false);
          toast("Payment  successfully approved!", {
            position: "bottom-right",
            theme: "dark",
          });
         
        }else {
          setIsLoading(false);
          toast(response, {
            position: "bottom-right",
            theme: "dark",
          });
        }
      } catch (error) {
        console.error(
          "Error:",
          error.response ? error.response.data : error.message
        );
        toast(error.message, {
          position: "bottom-right",
          theme: "dark",
        });
        setIsLoading(false);
        if (
          error.response &&
          (error.response.status === 401 ||
            error.response.data === "Invalid token")
        ) {
          dispatch(logoutUser());
          dispatch(resetItemGroup());
          dispatch(resetItems());
          navigate("/");
        }
      }
    }
  };

  const handleDecline = async (docEntry) => {
    setIsLoading(true);
    const updatedPayment = updateOutGoingPayment(OutGoingPayment, docEntry);
    if (updatedPayment) {
      if (userData.AppLevel === 1) {
        updatedPayment.level1StatusId = 2;
      }
      if (userData.AppLevel === 2) {
        updatedPayment.level2StatusId = 2;
      }
      if (userData.AppLevel === 3) {
        updatedPayment.level3StatusId = 2;
      }
      let dataToSend;
     
     dataToSend = {
        companyName: selectedDatabase,
        payment: updatedPayment,
      };
      
      try {
        // const response = await axios.post(postOutGoingPayment, dataToSend, {
        //   headers: {
        //     wg_token: jwtToken,
        //   },
        // });
        const response = await PostData(postOutGoingPayment,dataToSend,jwtToken,dispatch,navigate)
        if (response === "OK") {
        fetchPayments();
        setIsLoading(false);
        toast("Payment declined successfully!", {
          position: "bottom-right",
          theme: "dark",
        });
        setDatabaseChange(false);
      }else {
        setIsLoading(false);
        toast(response, {
          position: "bottom-right",
          theme: "dark",
        });
      }
      } catch (error) {
        console.error(
          "Error:",
          error.response ? error.response.data : error.message
        );
        toast(error.message, {
          position: "bottom-right",
          theme: "dark",
        });
        setIsLoading(false);
        if (
          error.response &&
          (error.response.status === 401 ||
            error.response.data === "Invalid token")
        ) {
          dispatch(logoutUser());
          dispatch(resetItemGroup());
          dispatch(resetItems());
          navigate("/");
        }
      }
    }
  };

  const handleDetails = (docEntry) => {
    const paymentDetails = OutGoingPayment.find(
      (payment) => payment.docEntry === docEntry
    );
    setDetails(paymentDetails);
    setShow(true);
  };

  const companyNamesOnly =
    CompanyNames?.map((company) => company.companyName) || [];
  const branchNames = BranchNames?.map((branch) => branch.bplName) || [];

  const handleCompanyChange = (event, newValue) => {
    setSelectedCompany(newValue);
    if (newValue) {
      const matchedCompany = CompanyNames.find(
        (company) => company.companyName === newValue
      );
      setSelectedDatabase(matchedCompany.databaseName);
      setDatabaseChange(true);
      if (matchedCompany) {
        dispatch(fetchOutGoingPayment(userId, matchedCompany.databaseName,jwtToken));
        dispatch(fetchBranchList(matchedCompany.databaseName,jwtToken));
      }
    }
  };

  const handleApprovalChange = (event, newValue) => {
    setSelectedApproval(newValue);
  };

  const handleBranchChange = (event, newValue) => {
    setSelectedBranch(newValue);
  };

  const handlePayToChange = (event, newValue) => {
    setSelectedPayTo(newValue);
  };

  const handleAmountChange = (event) => {
    const value = event.target.value;
    if (!isNaN(value)) {
      const numericValue = Number(value);
      setAmount(numericValue);
    }
  };

  const filteredPayments = OutGoingPayment?.filter((item) => {
    if (selectedApproval && selectedApproval !== "All") {
      if (selectedApproval === "L1" && item.level1StatusId !== 1) return false;
      if (selectedApproval === "L2" && item.level2StatusId !== 1) return false;
      if (selectedApproval === "L3" && item.level3StatusId !== 1) return false;
    }
    if (selectedBranch && item.branch !== selectedBranch) return false;
    if (selectedPayTo && item.payTo !== selectedPayTo) return false;
    // debugger
    if (amount && !item.total.toString().includes(amount.toString()))
      return false;
    return true;
  });

  const handleBackNav = () => {
    navigate("/DashBoard");
  };
  const paginatedPayments = filteredPayments?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const payToValues = [
    ...new Set(OutGoingPayment?.map((payment) => payment.payTo)),
  ];
  // if (!userData || !userData.UserName) {
  //   return <Navigate to="/" />;
  // }

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 650;
      setIsMobile(mobile);
      
      // Ensure items are shown when not on mobile
      if (!mobile) {
        setShowItems(true);
      }
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

const handleshowitem =() => {
 if(isMobile) {
  setShowItems(prevState => !prevState);
 }
}

  return (
    <>
      <Header />
      <div className="dashImage"></div>
      <div className="container-fluid OutGoingPage">
        <div className="position-relative backButtonOp">
          <button onClick={handleBackNav} className="backIcondiv">
            <ArrowCircleLeftIcon />
            <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11 mb-0">
              Dashboard
            </p>
          </button>
        </div>
        <div className="OutGoingGradient"></div>

        <div className="out">
          <div className="OutGoingDiv">
            {isMobile && 
            <button className="show-item-button" onClick={handleshowitem}>Filters
            <FilterListIcon /></button>}
          {(isMobile && showItems) || !isMobile ? (
            <div className="FilterDiv row">
              <div className="CompanyNameDiv col-12 col-md-6 col-lg-3">
                <span className="CompanyNameIcon">
                  <GroupsIcon />
                </span>
                <Autocomplete
                  id="combo-box-demo"
                  className="companyName"
                  options={companyNamesOnly}
                  getOptionLabel={(option) => option}
                  onChange={handleCompanyChange}
                  value={selectedCompany}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      //   label="Matched Companies"
                      className="companyInput"
                      id="standard-basic"
                      variant="standard"
                      // value={selectedCompany}
                    />
                  )}
                />
              </div>
              <div className="CompanyNameDiv col-12 col-md-6 col-lg-3">
                <div className="ApprovalIcon iconDesign"></div>
                <Autocomplete
                  id="combo-box-demo"
                  className="companyName"
                  options={ApprovalList}
                  getOptionLabel={(option) => option}
                  onChange={handleApprovalChange}
                  value={selectedApproval}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Approval"
                      id="standard-basic"
                      variant="standard"
                      // value={selectedCompany}
                    />
                  )}
                />
              </div>
              <div className="CompanyNameDiv col-12 col-md-6 col-lg-3">
                <div className="branchIcon iconDesign"></div>
                <Autocomplete
                  id="combo-box-demo"
                  className="companyName"
                  options={branchNames}
                  getOptionLabel={(option) => option}
                  onChange={handleBranchChange}
                  value={selectedBranch}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Branch"
                      id="standard-basic"
                      variant="standard"
                      // value={selectedCompany}
                    />
                  )}
                />
              </div>
              <div className="CompanyNameDiv col-12 col-md-6 col-lg-3">
                <div className="PayToIcon iconDesign"></div>
                <Autocomplete
                  id="combo-box-demo"
                  className="companyName"
                  options={payToValues ? payToValues : null}
                  getOptionLabel={(option) => option}
                  onChange={handlePayToChange}
                  value={selectedPayTo}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pay To"
                      id="standard-basic"
                      variant="standard"
                      // value={selectedCompany}
                    />
                  )}
                />
              </div>
              <div className="CompanyNameDiv col-12 col-md-6 col-lg-3">
                <div className="AmountIcon iconDesign"></div>
                <TextField
                  id="standard-basic"
                  label="Amount"
                  variant="standard"
                  className="AmountSearch"
                  value={amount}
                  onChange={handleAmountChange}
                />
              </div>
            </div>) : null}
            <hr className="divider" />
            <div className="DataDiv">
              {paginatedPayments ? ( //&& paginatedPayments.length > 0
                paginatedPayments?.map((item) => (
                  <div className="outGoingPayment row mb-3" key={item.docEntry}>
                    <div className="Text col-12 col-md-6 d-flex gap-2">
                      <p className="mb-0">Ref: No </p>
                      <span className="fontSize">{item.docEntry}</span>
                    </div>
                    <div>
                    <div className="col-12 mb-2">
                      <div className="Text">
                        <p className="textDecoration">Payment To</p>
                        <p className="fontSize">{item.paymentTo}</p>
                      </div>
                      <div className="Text">
                        <p className="textDecoration">Pay To </p>
                        <p className="fontSize">{item.payTo}</p>
                      </div>
                    
                    <div>
                      <div className="Text">
                        <p className="textDecoration">G/L Account</p>
                        <p className="fontSize">{item.apServiceGlAccount}</p>
                      </div>
                      <div className="d-flex justify-content-around align-items-center">
                        <div className="Text">
                          <p className="textDecoration">Date</p>
                          <p className="fontSize">{item.postingDate}</p>
                        </div>
                        <div className="Text">
                          <p className="textDecoration">Total Amount</p>
                          <p className="fontSize">
                            ₹ {item.total.toLocaleString()}
                          </p>
                        </div>
                      </div>
                      <div className="OPButtons d-flex flex-column flex-md-row">
                        <button
                          className="Details mb-2 mb-md-0"
                          onClick={() => {
                            handleDetails(item.docEntry);
                          }}
                        >
                          Details
                        </button>
                        <button
                          className="PaymentApprove mb-2 mb-md-0"
                          onClick={() => {
                            handleApprove(item.docEntry);
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="PaymentDecline mb-2 mb-md-0"
                          onClick={() => {
                            handleDecline(item.docEntry);
                          }}
                        >
                          Decline
                        </button>
                      </div>
                    </div>
                    </div>
                    </div>
                    <div className="col-12 d-flex justify-content-around mt-2">
                      <div className="Text text-center">
                        <p className="textDecoration">L1</p>
                        <div
                          className={
                            item.level1StatusId === 1 ? "approved" : "waiting"
                          }
                        ></div>
                      </div>
                      <div className="Text text-center">
                        <p className="textDecoration">L2</p>
                        <div
                          className={
                            item.level2StatusId === 1 ? "approved" : "waiting"
                          }
                        ></div>
                      </div>
                      <div className="Text text-center">
                        <p className="textDecoration">L3</p>
                        <div
                          className={
                            item.level3StatusId === 1 ? "approved" : "waiting"
                          }
                        ></div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>there is no data found</div>
              )}
              {/* {details && details.length > 0 ? (details.map((item, index) => ( */}
              <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
              >
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    <p className="m-0">
                      {userData?.companyName} - {details.branch}
                    </p>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody">
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <p className="m-0">Customer Details</p>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="d-flex flex-column flex-md-row">
                        <div className="leftDiv col-md-6">
                          <div className="TextDetails">
                            <p className="textDecoration">Customer Name</p>
                            <p>
                              {details && details.customerName
                                ? details.customerName
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">
                              Balance Outstanding - total
                            </p>
                            <p>
                              {details && details.balanceOutstanding
                                ? details.balanceOutstanding
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Contact Person</p>
                            <p>
                              {details && details.contactPerson
                                ? details.contactPerson
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">GST Number</p>
                            <p>
                              32AAJFA6651L1ZC
                              {/* {details && details.fromAccount
                                ? details.fromAccount
                                : "-"} */}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Last Payment Date</p>
                            <p>
                              {details && details.lastPaymentDate
                                ? details.lastPaymentDate
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="rightdiv col-md-6">
                          <div className="TextDetails">
                            <p className="textDecoration">Customer Code</p>
                            <p>
                              {details && details.customerCode
                                ? details.customerCode
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">
                              Balance Outstanding - Branch
                            </p>
                            <p>
                              {details && details.branchBalance
                                ? details.branchBalance
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Contact Number</p>
                            <p>
                              {details && details.contactNumber
                                ? details.contactNumber
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Group</p>
                            <p>
                              {details && details.groupName
                                ? details.groupName
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">
                              Last Payment Amount
                            </p>
                            <p>
                              {details && details.lastPaymentAmount
                                ? details.lastPaymentAmount
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <p className="m-0">Invoices</p>
                    </AccordionSummary>
                    <AccordionDetails className="InvoiceAccordian">
                      <table className="InvoiceTable">
                        <thead>
                          <tr>
                            <th className="p-2">Invoice No</th>
                            <th className="p-2">Invoice Date</th>
                            <th className="p-2">Reference No</th>
                            <th className="p-2">Document Total</th>
                            <th className="p-2">Document Due Date</th>
                            <th className="p-2">Paid Sum</th>
                          </tr>
                        </thead>
                        <tbody>
                          {details &&
                            details.invoices &&
                            details.invoices.map((invoice, index) => (
                              <tr key={index}>
                                <td className="p-2">{invoice.invoiceNo}</td>
                                <td className="p-2">{invoice.invoiceDate}</td>
                                <td className="p-2">
                                  {invoice.referenceNumber}
                                </td>
                                <td className="p-2">
                                  {invoice.invoiceDocTotal}
                                </td>
                                <td className="p-2">{invoice.docDueDate}</td>
                                <td className="p-2">{invoice.paidSum}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <p className="m-0">Banking Details</p>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="d-flex">
                        <div className="leftDiv">
                          <div className="TextDetails">
                            <p className="textDecoration">Form Account</p>
                            <p>
                              {details && details.fromAccount
                                ? details.fromAccount
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Payment Type</p>
                            <p>
                              {details && details.paymentType
                                ? details.paymentType
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Date</p>
                            <p>
                              {details && details.postingDate
                                ? details.postingDate
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Pay To</p>
                            <p>
                              {details && details.payTo ? details.payTo : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Payment Amount</p>
                            <p>
                              {details && details.total ? details.total : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Payment Mode</p>
                            <p>
                              {details && details.paymentMode
                                ? details.paymentMode
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Pre-Remarks</p>
                            <p>
                              {details && details.preRemarks
                                ? details.preRemarks
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Remarks</p>
                            <p>
                              {details && details.comments
                                ? details.comments
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="rightdiv">
                          <div className="TextDetails">
                            <p className="textDecoration">E-Net Beneficiary</p>
                            <p>
                              {details && details.eNetBeneficiary
                                ? details.eNetBeneficiary
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Beneficiary Name</p>
                            <p>
                              {details && details.beneficiaryName
                                ? details.beneficiaryName
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration" p>
                              Beneficiary Bank
                            </p>
                            <p>
                              {details && details.beneficiaryBank
                                ? details.beneficiaryBank
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Account No</p>
                            <p>
                              {details && details.accNo ? details.accNo : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">IFSC Code</p>
                            <p>
                              {details && details.ifsc ? details.ifsc : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Prepared By</p>
                            <p>
                              {details && details.preparedBy
                                ? details.preparedBy
                                : "-"}
                            </p>
                          </div>
                          <div className="TextDetails">
                            <p className="textDecoration">Verified By</p>
                            <p>
                              {details && details.verifiedBy
                                ? details.verifiedBy
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <p className="m-0">G/L Details</p>
                    </AccordionSummary>
                    <AccordionDetails>
                      <table className="InvoiceTable">
                        <thead>
                          <tr>
                            <th className="p-2">G/L Account</th>
                            <th className="p-2">Acc Name</th>
                            <th className="p-2">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {details &&
                            details.bankAccount &&
                            details.bankAccount.map((invoice, index) => (
                              <tr key={index}>
                                <td className="p-2">
                                  {invoice && invoice.glAccount
                                    ? invoice.glAccount
                                    : "-"}
                                </td>
                                <td className="p-2">
                                  {invoice && invoice.glaccName
                                    ? invoice.glAccount
                                    : "-"}
                                </td>
                                <td className="p-2">{invoice.glamount}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </AccordionDetails>
                  </Accordion>
                </Modal.Body>
              </Modal>
              {/* ))) : (
        <div>
            <p>There is no record found</p>
        </div>
      )} */}
            </div>
          </div>
        </div>
        <div className="paginationOut">
          <TablePagination
            component="div"
            count={filteredPayments && filteredPayments.length} // Use the length of the item data
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            className="w-100"
          />
        </div>
      </div>
      {isLoading && (
        <div className="loader position-absolute ">
          (<SunspotLoader />)
        </div>
      )}
      <ToastContainer/>
      <Footer />
    </>
  );
};

export default OutGoingPayment;
